/**
 * @Category React Hook function
 * Provide single source to manage application static menus items
 * 
**/


export default function useMenus() {
    
    
    return {
	navbarTopRight: [],
	navbarTopLeft: [],
	navbarSideLeft: [
  {
    "to": "/home",
    "label": "Home",
    "icon": "pi pi-home",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/allclassesattendancevw",
    "label": "All Classes Attendance",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/allstudentsenrollmentvw",
    "label": "Students Enrollment",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/studentvideovw",
    "label": "Class Video",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/paymentssummaryvw",
    "label": "Payments Summary",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/home",
    "label": "Courses",
    "icon": "pi pi-file-edit",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/courses/add",
        "label": "New Course",
        "icon": "pi pi-server",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/courses",
        "label": "List/View Courses",
        "icon": "pi pi-sign-out",
        "iconcolor": "",
        "target": "",
      }
    ]
  },
  {
    "to": "/home",
    "label": "Batch",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/coursebatches/add",
        "label": "New Batch",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/coursebatches",
        "label": "Listview Batch",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      }
    ]
  },
  {
    "to": "/home",
    "label": "Students",
    "icon": "pi pi-users",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/students/add",
        "label": "New Student",
        "icon": "pi pi-plus-circle",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/students",
        "label": "List/View Student",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      }
    ]
  },
  {
    "to": "/home",
    "label": "Users",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/usermaster/add",
        "label": "New User",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/usermaster",
        "label": "List Users",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      }
    ]
  },
  {
    "to": "/home",
    "label": "Teachers",
    "icon": "pi pi-user",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/teachers/add",
        "label": "New Teacher",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/teachers",
        "label": "List/View Teachers",
        "icon": "pi pi-user-edit",
        "iconcolor": "",
        "target": "",
      }
    ]
  },
  {
    "to": "/home",
    "label": "Classes",
    "icon": "pi pi-ticket",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/classes/add",
        "label": "New Class",
        "icon": "pi pi-folder",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/classes",
        "label": "List/View Classes",
        "icon": "pi pi-sliders-h",
        "iconcolor": "",
        "target": "",
      }
    ]
  },
  {
    "to": "/home",
    "label": "Performance",
    "icon": "pi pi-thumbs-up",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/performance/add",
        "label": "New Perormance",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/performance",
        "label": "List/View Perormance",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      }
    ]
  },
  {
    "to": "/home",
    "label": "Class Attendance",
    "icon": "pi pi-chevron-down",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/studentclassattendance/add",
        "label": "New Attendance",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/studentclassattendance",
        "label": "List/View Attendance",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      }
    ]
  },
  {
    "to": "/home",
    "label": "Course Attendance",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/attendance/add",
        "label": "New Attendance",
        "icon": "pi pi-user",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/attendance",
        "label": "List/View Attendance",
        "icon": "pi pi-table",
        "iconcolor": "",
        "target": "",
      }
    ]
  },
  {
    "to": "/home",
    "label": "Enrollments",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/enrollments/add",
        "label": "New Enrollment",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/enrollments",
        "label": "List/View Enrollment",
        "icon": "pi pi-verified",
        "iconcolor": "",
        "target": "",
      }
    ]
  },
  {
    "to": "/home",
    "label": "Payments",
    "icon": "pi pi-wallet",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/payments/add",
        "label": "Payment Entry",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/payments",
        "label": "List/View Payments",
        "icon": "pi pi-wallet",
        "iconcolor": "",
        "target": "",
      }
    ]
  }
],
	completionStatus: [    
{value: "Completed", label: "Completed"},
	{value: "In Progress", label: "In Progress"},
	{value: "Withdrawn", label: "Withdrawn"}
    ],
	paymentMethod: [    
{value: "Card", label: "Card"},
	{value: "Cash", label: "Cash"},
	{value: "BankTransfer", label: "Banktransfer"},
	{value: "UPI", label: "Upi"}
    ],
	paymentStatus: [    
{value: "Pending", label: "Pending"},
	{value: "Paid", label: "Paid"}
    ],
	gender: [    
{value: "Male", label: "Male"},
	{value: "Female", label: "Female"}
    ],
	status: [    
{value: "Active", label: "Active"},
	{value: "Dropout", label: "Dropout"},
	{value: "Not Enrolled", label: "Not Enrolled"}
    ],
	status2: [    
{value: "Active", label: "Active"},
	{value: "Inactive", label: "Inactive"}
    ],
        exportFormats: {
            print: {
                label: 'Print',
                icon: 'pi pi-print',
                type: 'print',
                ext: '',
            },
            pdf: {
                label: 'Pdf',
                icon: 'pi pi-file-pdf',
                type: 'pdf',
                ext: 'pdf',
            },
            excel: {
                label: 'Excel',
                icon: 'pi pi-file-excel',
                type: 'excel',
                ext: 'xlsx',
            },
            csv: {
                label: 'Csv',
                icon: 'pi pi-table',
                type: 'csv',
                ext: 'csv',
            },
        },
    }
}